class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.hoverMediaQuery = window.matchMedia('(min-width: 990px)');

    if (this.hoverMediaQuery.matches) this.initHoverMenu();
    this.hoverMediaQuery.addEventListener('change', (event) => {
      if (event.matches) {
        this.initHoverMenu();
      } else {
        this.destroyHoverMenu();
      }
    });
  }

  initHoverMenu() {
    if (this.hoverInitialized) return;
    this.hoverInitialized = true;

    this.onMouseEnter = () => {
      this.closeSiblingMenus();
      this.openMenu();
    };
    this.onMouseLeave = () => this.close();
    this.onSummaryClick = (event) => event.preventDefault();

    this.addEventListener('mouseenter', this.onMouseEnter);
    this.addEventListener('mouseleave', this.onMouseLeave);
    this.summary.addEventListener('click', this.onSummaryClick);
  }

  destroyHoverMenu() {
    if (!this.hoverInitialized) return;
    this.hoverInitialized = false;

    this.removeEventListener('mouseenter', this.onMouseEnter);
    this.removeEventListener('mouseleave', this.onMouseLeave);
    this.summary.removeEventListener('click', this.onSummaryClick);
  }

  openMenu() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
  }

  closeSiblingMenus() {
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu.close();
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (!this.mainDetailsToggle.open) {
      document.documentElement.style.removeProperty('--header-bottom-position-desktop');
      return;
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

function initDesktopHeaderSubmenuHover() {
  const hoverMediaQuery = window.matchMedia('(min-width: 990px)');

  const setupNestedSubmenuHover = () => {
    document.querySelectorAll('.header__inline-menu .header__submenu > li > details').forEach((details) => {
      if (details.dataset.hoverInit) return;
      details.dataset.hoverInit = 'true';

      const summary = details.querySelector('summary');
      if (!summary) return;

      details.addEventListener('mouseenter', () => {
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', true);
      });
      details.addEventListener('mouseleave', () => {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', false);
      });
      summary.addEventListener('click', (event) => {
        if (hoverMediaQuery.matches) event.preventDefault();
      });
    });
  };

  setupNestedSubmenuHover();
  hoverMediaQuery.addEventListener('change', setupNestedSubmenuHover);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDesktopHeaderSubmenuHover);
} else {
  initDesktopHeaderSubmenuHover();
}
